/**
 * 科创微视
 */

import Container from '@/containers';

const videoRouter = {
    path: '/video',
    component: Container,
    redirect: '/video/index',
    name: 'Video',
    meta: {
        title: '科创微视'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/video/index'),
            name: 'VideoIndex',
            meta: {
                title: '科创微视',
                showAddBtn:true
            }
        }
    ]
};

export default videoRouter;